<app-wizard
  [prevButtonEnabled]="true"
  [nextButtonEnabled]="true"
  [prevButtonText]="prevButtonText()"
  [nextButtonText]="nextButtonText()"
  [prevButtonHasChevron]="prevButtonHasChevron()"
  [nextButtonHasChevron]="nextButtonHasChevron()"
  [items]="items()"
  (stepSelection)="onStepSelection($event)"
  (nextButtonClicked)="onNextButtonClick()"
  (prevButtonClicked)="onPreviousButtonClick()"
>
  <app-wizard-step
    stepId="form-wizard-progress-tab1"
    [stepNumber]="1"
    [isActive]="stepIndex() == 1"
  >
    <app-general-terms-and-conditions-step-form
      [formGroupInput]="termsAndConditions"
      [contractText]="contractText"
    />
  </app-wizard-step>
  <app-wizard-step
    stepId="form-wizard-progress-tab2"
    [stepNumber]="2"
    [isActive]="stepIndex() == 2"
  >
    <app-personal-data-step-form [formGroupInput]="personalData" />
  </app-wizard-step>
  <app-wizard-step
    stepId="form-wizard-progress-tab3"
    [stepNumber]="3"
    [isActive]="stepIndex() == 3"
  >
    <app-legal-person-validated-form
      [formGroupInput]="legalPersonForm"
      [taxNumberDisabled]="false"
      [showFillDataButton]="true"
    />
  </app-wizard-step>
  <app-wizard-step
    stepId="form-wizard-progress-tab4"
    [stepNumber]="4"
    [isActive]="stepIndex() == 4"
  >
    <app-document-upload-form [formGroupInput]="documentUpload" />
  </app-wizard-step>
  <app-wizard-step
    stepId="form-wizard-progress-tab5"
    [stepNumber]="5"
    [isActive]="stepIndex() == 5"
  >
    <app-proof-of-professional-status-form
      [formGroupInput]="proofOfProfessionalStatus"
    />
  </app-wizard-step>
</app-wizard>
